import { NgModule } from '@angular/core';
import { NavigationsModule } from './features/navigations/navigations.module';
import { OyanUiRouterModule } from './oyan-ui.router.module';

@NgModule({
  imports: [NavigationsModule, OyanUiRouterModule]
})
export class OyanUiModule {}
